<div class="dropdown" appDropdownAutoLocate [menuWidth]="data.rect.width" [dropdownWidth]="data.width"
    [rect]="data.rect">
    <app-box-arrow [colorChange]="true"></app-box-arrow>
    <div class="d-flex justify-content-center align-items-center" *ngIf="!browsingHistory.length">
        <h5 style="line-height: 43px" class="no-content">暂无内容</h5>
    </div>
    <div class="mb-3 historylist fs-14" *ngIf="browsingHistory.length && (!user || !user.id)">
        <a [routerLink]="['/play',item.vKey]" *ngFor="let item of browsingHistory">
            <span class="d-flex item px-3 align-items-center">
                <span class="title">{{ item.title }}</span>
                <span class="episode">
                    <span *ngIf="['sport', 'drama','tv-series', 'anime', 'variety'].indexOf(item.category) > -1">{{
                        item.mTitle }}</span>
                </span>
                <span class="timestamp">{{ item.timestamp | relativeTime }}</span>
            </span>
        </a>
    </div>

    <div class="mb-3 historylist fs-14" *ngIf="browsingHistory.length && user && user.id">
        <a [routerLink]="['/play',item.key]" *ngFor="let item of browsingHistory">
            <span class="d-flex item px-3 align-items-center">
                <span class="title">{{ item.title }}</span>
                <span class="episode">
                    <span>{{ item.lastUpdatedItem !== '-' ? item.lastUpdatedItem : (item.userBehaviors?.lastWatchedMedia.playedTime | timeFormat) }}</span>
                </span>
                <span class="timestamp">{{ timeStampSubstr(item.userBehaviors?.lastWatch) }}</span>
            </span>
        </a>
    </div>

    <div class="dropdown-footer d-flex align-items-center">
        <div class="d-flex align-items-center jbutton jbutton-default"
           [ngClass]="{'disabled': !browsingHistory.length}"
           (click)="clearHistory()">
            <span class="iconfont iconshanchu"></span>
            <!-- <span>清空</span> -->
        </div>

        <a [routerLink]="['/user/watch-history']" class="d-flex align-items-center jbutton jbutton-default ml-auto"
            [ngClass]="{'disabled': !user || !user.id}">
            <span class="fs-12">更多</span>
            <span class="iconfont iconchakangengduo fs-16"></span>

        </a>
    </div>
</div>